<template>
  <div class="jingzonglv-modal">

    <el-dialog
      :visible.sync="visible"
      :show-close="false"
      :close-on-click-modal="false">
      <!-- 头部 -->
      <div class="custom-header">
        <!-- 关闭 -->
        <div class="el-dialog__headerbtn" @click="closeModal">
          <i class="el-dialog__close el-icon el-icon-close"></i>
        </div>
      </div>

      <div class="body-box">
        <div class="left-box">

          <div class="header-box">
            <div class="title">欢迎使用上上签</div>
            <div class="desc">领先的旅游同业签证办理平台</div>
          </div>

          <div class="item-box">
            <div class="item" v-for="(item, index) in descList" :key="index">
              <img :src="item.url">
              <div class="title-item">{{item.title}}</div>
              <div class="desc-item">{{item.desc}}</div>
            </div>
          </div>

        </div>
        <div class="right-box">
          <div class="header-box">首次下单，咨询商务经理</div>
          <div class="name" v-if="peerData && peerData.bd_name">{{peerData && peerData.bd_name.slice(peerData.bd_name.indexOf('-') + 2)}}</div>
          <div class="phone" v-if="peerData && peerData.bd_phone">{{peerData && peerData.bd_phone}}</div>
          <template v-if="peerData && peerData.wx_qrcode">
            <div class="line-box"></div>
            <div class="wechat-box"><img src="../../../assets/imgs/index/wechat.png" class="wechat-icon">微信扫一扫，添加好友咨询</div>
            <img class="wechat-img" :src="peerData && peerData.wx_qrcode">
          </template>
        </div>
      </div>

    </el-dialog>

  </div>
</template>

<script>

import { mapState } from 'vuex';
import icon1 from '../../../assets/imgs/index/icon_1.png';
import icon2 from '../../../assets/imgs/index/icon_2.png';
import icon3 from '../../../assets/imgs/index/icon_3.png';
import icon4 from '../../../assets/imgs/index/icon_4.png';

export default {
  name: 'jingzonglv-modal',
  props: {
    show: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  data() {
    return {
      descList: [
        {
          title: '智能处理',
          desc: '护照、身份证信息自动识别填表',
          url: icon1,
        },
        {
          title: '一键下载办签资料',
          desc: '同步更新使馆签证资料，下载便捷',
          url: icon2,
        },
        {
          title: '1对1专家服务',
          desc: '签证专家7x12小时实时响应',
          url: icon3,
        },
        {
          title: '顺丰包邮、上门取件',
          desc: '出签顺丰包邮，部分地区顺丰上门取件',
          url: icon4,
        },
      ],
    };
  },
  computed: {
    ...mapState('user', [
      'peerData',
    ]),

    visible: {
      get() {
        return this.show;
      },
      set(newValue) {
        if (!newValue) {
          localStorage.setItem('palmyouModalshow', true);
        }
        this.$emit('visibleSync', newValue);
      },
    },
  },
  created() {
  },
  methods: {
    // 关闭对话框回调
    closeModal() {
      this.visible = false;
    },
  },
};
</script>

<style lang="less" scoped>
  .jingzonglv-modal{
    .body-box{
      display: flex;
      .left-box{
        width: 540px;
        .header-box{
          display: flex;
          align-items: center;
          padding: 40px 0 40px 40px;
          margin-bottom: 20px;
          .title{
            font-size: 20px;
            color: #333333;
            font-weight: 600;
          }
          .desc{
            font-size: 14px;
            color: #777777;
            margin-left: 10px;
          }
        }
        .item-box{
          display: flex;
          padding-left: 20px;
          flex-wrap: wrap;
          .item{
            margin: 0 0px 60px 0px;
            display: flex;
            flex-direction: column;
            width: 240px;
            align-items: center;
            img{
              width: 82px;
              height: 88px;
            }
            .title-item{
              font-size: 16px;
              color: #353539;
              margin-top: 18px;
            }
            .desc-item{
              font-size: 14px;
              color: #aaaaaa;
              margin-top: 15px;
              text-align: center;
              line-height: 18px;
            }
          }
        }
      }
      .right-box{
        width: 300px;
        background-color: rgba(94, 155, 225, .1);
        padding: 58px 45px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        .header-box{
          font-size: 16px;
          color: #333333;
          margin-bottom: 20px;
        }
        .name{
          font-size: 16px;
          color: #333333;
          margin-bottom: 10px;
          font-weight: 600;
          text-align: center;
        }
        .phone{
          font-size: 16px;
          color: #333333;
        }
        .line-box{
          width: 30px;
          height: 1px;
          background-color: rgba(94, 155, 225, .5);
          margin: 25px 0;
        }
        .wechat-box{
          font-size: 14px;
          color: #777777;
          margin-bottom: 12px;
          display: flex;
          align-items: center;
          .wechat-icon{
            margin-right: 10px;
          }
        }
        .wechat-img{
          width: 210px;
          height: 280px;
          box-shadow: 0 2px 4px 0 rgba(0,0,0,.12), 0 0 6px 0 rgba(0,0,0,.04);
        }
      }
    }
  }
</style>

<style lang="less">
@import "../../../assets/less/variable.less";
.jingzonglv-modal{

  .el-dialog__header {
    display: none;
  }

  .el-dialog__body {
    padding: 0;
  }

  .el-dialog--small{
    width: 840px;
    .el-dialog__close {
      position: absolute;
      right: 20px;
      top: 16px;
      width: 19px;
      height: 19px;
      transform: rotateZ(45deg);
      cursor: pointer;

      &::before {
        content: "";
        display: block;
        width: 19px;
        position: absolute;
        top: 9px;
        left: 0;
        border-top: 1px solid #777;
      }

      &::after {
        content: "";
        display: block;
        height: 19px;
        position: absolute;
        top: 0;
        left: 9px;
        border-left: 1px solid #777;
      }

      &:hover {
        &::before,
        &::after {
          border-color: @main;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/index/components/jingzonglv-modal.vue